import * as types from "./types";

const mutations = {
  [types.SET_RECIPE_V2](state, payload) {
    state.recipe_v2 = JSON.parse(JSON.stringify(payload));
  },
  [types.SET_RECIPE_ID](state, payload) {
    state.recipeId = payload;
    state.recipe_v2.recipe_id = payload;
  },
  [types.SET_INIT_RECIPE](state, payload) {
    state.initRecipe = JSON.parse(JSON.stringify(payload));
  },
  [types.SET_DEFAULT_RECIPE](state, payload) {
    state.defaultRecipe = JSON.parse(JSON.stringify(payload));
  },
  [types.SET_SAVED_RECIPE](state, payload) {
    state.savedRecipe = JSON.parse(JSON.stringify(payload));
  },
  [types.REMOVE_COMPONENT](state, componentName) {
    delete state.recipe_v2.components[componentName];
    state.recipe_v2.components = {...state.recipe_v2.components};
  },
  [types.REMOVE_COMPONENT_PROPERTY](state, { componentName, property }) {
    if (componentName.search('/') !== -1) {
      const component = componentName.split('/');
      delete state.recipe_v2.components[component[0]].sub_components[component[1]][property];
    } else {
      delete state.recipe_v2.components[componentName][property];
    }
  },
  [types.CREATE_COMPONENT](state, componentName) {
    state.recipe_v2.components = { ...state.recipe_v2.components, [componentName]: {} };
  },
  [types.UPDATE_COMPONENT](state, { componentName, data }) {
    if (componentName.search('/') !== -1) {
      const component = componentName.split('/');
      const componentData = state.recipe_v2.components[component[0]];

      if (!componentData?.sub_components[component[1]]) return false;

      state.recipe_v2.components = {
        ...state.recipe_v2.components,
        [component[0]]: {
          ...componentData,
          sub_components: { ...componentData.sub_components, [component[1]]: data },
        }
      };
    } else {
      if (!state.recipe_v2.components[componentName]) return false;

      state.recipe_v2.components = {
        ...state.recipe_v2.components,
        [componentName]: {
          ...data
        }
      };
    }
  },
  [types.UPDATE_UGC](state, {componentName, ugcObj, subgroup}){
    if (state.recipe_v2.components[componentName]) {
      const ugc = JSON.parse(JSON.stringify(ugcObj));
      state.recipe_v2.components[componentName].group = 'ugc';
      state.recipe_v2.components[componentName].subgroup = subgroup;
      state.recipe_v2.components[componentName].ugc = {
        ...ugc
      }
    }
  },
  [types.SAVE_PERSONALIZATION](state, { componentName, personalization }) {
    state.recipe_v2.components[componentName].personalization = [
      ...personalization
    ]
  },
  [types.REMOVE_PERSONALIZATION](state, componentName) {
    delete state.recipe_v2.components[componentName].personalization;
  },
  [types.SET_INVALID_UGC_COMPONENTS](state, invalidUGCComponents) {
    state.invalidUGCComponents = [...invalidUGCComponents];
  },

  [types.SET_SUBCOMPONENT_TOOLKIT](state, { componentID, subComponentID, payload }) {
    if (
      state.recipe_v2?.components?.[componentID]?.sub_components?.[subComponentID]
    ) state.recipe_v2.components[componentID].sub_components[subComponentID].toolkit_options = payload
  },
};

export default mutations;
